import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import './App.css';
import Home from './Component/Home';
import Product from './Component/Product';
import MsLogin from './Component/Login';
import { msalInstance } from './config';
import Admin from './Admin/Admin';
import axios from 'axios';


function getCookie(name) {
  const cookieArr = document.cookie.split(';');
  for (const cookie of cookieArr) {
    const [key, value] = cookie.trim().split('=');
    if (key === name) return decodeURIComponent(value);
  }
  return null;
}
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [getUser, setGetUser] = useState({});
  const [organization, setOrganization] = useState();
  const [login, setLogin] = useState("false");
  const [token, setToken] = useState(getCookie("accessToken"));
  const [diffOrg, setDiffOrg] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [allAccessToken, setAllAccessToken] = useState("");

  const navigate = useNavigate();

  const broadcastChannel = new BroadcastChannel('auth_channel');

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        await msalInstance.initialize();
        let accounts = msalInstance.getAllAccounts();

        if (accounts.length > 0) {
          setIsAuthenticated(true);
          let accessTokenResponse = await msalInstance.acquireTokenSilent({
            scopes: ["User.Read"],
            account: accounts[0],
          });


          const response = await axios.get("https://onehum-backend.acuitas360.com/user/alluser", {
            headers: { Authorization: `Bearer ${accessTokenResponse.idToken}` },
          });

          setAllAccessToken(accessTokenResponse.idToken)


          const user = response.data.users;
          // console.log(response.data);
          setAllUsers(user);
          setGetUser(user[0]);
          setOrganization(user[0].organization.name.toLowerCase());

          if (response.data && response.data.token && response.data.token.length > 0) {
            document.cookie = `accessToken=${response.data.token}; path=/; max-age=3600`;
            setToken(response.data.token);
          }

          const userWithTimestamp = {
            data: user[0],
            timestamp: Date.now(),
          };
          localStorage.setItem("onehumUser", encodeURIComponent(JSON.stringify(userWithTimestamp)));
          localStorage.setItem("allAccessToken", encodeURIComponent(accessTokenResponse.idToken));

          if (user.length > 0) {

            const organ = user.map(u => u.organization.name);
            const filteredOrg = organ.filter(org => org !== user[0].organization.name); // `orgName` is the currently selected organization name
            setDiffOrg(filteredOrg);

          }
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    const userCookie = decodeURIComponent(localStorage.getItem("onehumUser"));
    const tokenCookie = getCookie("accessToken");
    const allAccessToken2 = decodeURIComponent(localStorage.getItem("allAccessToken"));

    if (userCookie) {
      try {
        const parsedUser = JSON.parse(userCookie);
        const currentTime = Date.now();
        const oneHour = 3600 * 1000;

        if (parsedUser && parsedUser.timestamp && currentTime - parsedUser.timestamp < oneHour) {
          setGetUser(parsedUser.data);
          setOrganization(parsedUser.data.organization.name.toLowerCase());
          setAllAccessToken(allAccessToken2)
          setDiffOrg([]);
          if (tokenCookie) setToken(tokenCookie);
          setIsAuthenticated(true);
        } else {
          localStorage.removeItem("onehumUser");
          localStorage.removeItem("allAccessToken");
          checkAuthentication();
        }
      } catch (error) {
        console.error("Error parsing localStorage data:", error);
        localStorage.removeItem("onehumUser");
        localStorage.removeItem("allAccessToken");
        checkAuthentication();
      }
    } else {
      checkAuthentication();
    }
  }, [login]);

  useEffect(() => {
    broadcastChannel.onmessage = async (event) => {
      if (event.data === 'logout') {
        await handleLogout(false); // Ensure all tabs log out
      }
    };
    return () => broadcastChannel.close();
  }, []);



  const handleLogout = async (broadcast = true) => {
    try {
      if (isAuthenticated) {
        await msalInstance.logoutPopup();
      }

      setIsAuthenticated(false);
      setOrganization(null);
      setGetUser(null);
      document.cookie = "accessToken=; max-age=0; path=/";
      localStorage.removeItem("onehumUser");
      localStorage.removeItem("allAccessToken");
      sessionStorage.clear();

      msalInstance.getAllAccounts().forEach((account) => {
        msalInstance.clearCacheForAccount(account);
      });

      if (broadcast) broadcastChannel.postMessage('logout');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const changeUser = (e) => {
    // console.log(e);
    const user = allUsers.find(u => u.organization.name === e);
    if (user) {
      setGetUser(user);
      const newOrg = user.organization.name.toLowerCase();
      setOrganization(newOrg); // Update the organization name state

      const userWithTimestamp = {
        data: user,
        timestamp: Date.now(),
      };
      localStorage.setItem("onehumUser", encodeURIComponent(JSON.stringify(userWithTimestamp)));

      if (allUsers.length > 0) {

        const organizations = allUsers.map(u => u.organization.name);
        const filteredOrg = organizations.filter(org => org !== user.organization.name); // `orgName` is the currently selected organization name

        setDiffOrg(filteredOrg);

      }

      navigate(`/${newOrg}/home`);
    }
  };



  const loginSetLogin = (e) => {
    setLogin(e);
  };



  return (
    <>
      {organization && getUser.id ? (
        <Routes key={organization}> {/* Use a key to force re-render on organization change */}
          <Route path="/" element={isAuthenticated ? <Navigate to={`/${organization}/home`} /> : <MsLogin setLogin={setLogin} />} />
          <Route path={`/${organization}/home`} element={isAuthenticated ? <Home user={getUser}  logout={handleLogout} diffOrg={diffOrg} changeUser={changeUser} /> : <Navigate to="/" />} />
          {getUser.modules.map((item) => (
            <Route
              key={item.title.toLowerCase()}
              path={`/${organization}/${item.title.toLowerCase()}`}
              element={isAuthenticated ? <Product user={getUser} token={allAccessToken} organization={organization} module={item} logout={handleLogout} /> : <Navigate to="/" />}
            />
          ))}
          <Route path="/admin" element={isAuthenticated ? (token ? <Admin user={getUser} /> : <Navigate to="/" />) : <Navigate to="/" />} />
        </Routes>
      ) : (
        <MsLogin setLogin={setLogin} />
      )}
    </>
  );

}

export default App;
